import { pushToAdobeDataLayer } from "utils-lib/analytics/adobeDataLayer"

const SEARCH_CLICK = "global-search-magnifying-glass-click"
const EXIT_CLICK = "global_search_searchbox_exit_esc_click"
const ONBLUR_EXIT_CLICK = "global_search_searchbox_exit_clickout"

export const pushSearchClickData = () => {
  const acdlData = {
    clicks: {
      object_content: {
        siteSearch: "Global",
        eventName: SEARCH_CLICK,
      },
    },
  }

  pushToAdobeDataLayer(SEARCH_CLICK, acdlData)
}

export const pushExitClickData = () => {
  const acdlData = {
    clicks: {
      object_content: {
        siteSearch: "Global",
        eventName: EXIT_CLICK,
      },
    },
  }

  pushToAdobeDataLayer(EXIT_CLICK, acdlData)
}

export const pushExitOnBlurData = () => {
  const acdlData = {
    clicks: {
      object_content: {
        siteSearch: "Global",
        eventName: ONBLUR_EXIT_CLICK,
      },
    },
  }

  pushToAdobeDataLayer(ONBLUR_EXIT_CLICK, acdlData)
}
